import { trackEvent, trackPosthog } from "../../helper/tracking/tracking";

export class GtStepTracker {

    private tracked: string[] = [];

    public constructor(
        private initialStep = "login"
    ) {

    }

    public track(step: string, productId: string, productName, productPrice: number, paymentMethod) {

        if (this.tracked.indexOf(step) !== -1) {
            return;
        } else {

            if (step !== this.initialStep) {
                this.track(this.initialStep, productId, productName, productPrice, paymentMethod);
            }

            let googleStep = undefined;
            let googleOption = undefined;

            if (step === "login") {
                googleStep = 1;
            }

            if (step === "checkout-voucher" || step === "product-choose" || step === "pass-choose") {
                googleStep = 2;
            }

            if (step === "payment-choose") {
                googleStep = 3;
            }

            if (step === "payment") {
                googleStep = 4;
                googleOption = paymentMethod;
            }

            if (step === "success") {
                googleStep = 5;
            }

            trackEvent(
                "checkout",
                {
                    ecommerce: {
                        "checkout": {
                            "actionField": {
                                "step": googleStep,
                                "option": googleOption,
                                "action": "checkout"
                            },
                            "products": [
                                {
                                    "id": productId,
                                    "name": productName,
                                    "category": "Kurs",
                                    "price": 119
                                }
                            ]
                        }
                    }
                }
            );

            this.tracked.push(step);

        }


    }

    public reset() {
        this.tracked = [];
    }
}
